import {
    Route,
    Routes,
    Navigate
} from "react-router-dom"

import { HomeScreen } from "../pages/Home"
import { ListNewsScreen } from "../pages/ListNews"
import { NewsScreen } from "../pages/News"
import { ArticleScreen } from "../pages/Article"
import { ContactScreen } from "../pages/Contact"
import { LocationScreen } from "../pages/Location"
import { SearchScreen } from "../pages/Search"
import { EntityScreen } from "../pages/Entity"
import { ListVideosScreen } from "../pages/ListVideos"
import { DirectoryScreen } from "../pages/Directory"
import { FilesScreen } from "../pages/Files"
import { NotFoundScreen } from "../pages/NotFound"

export function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<HomeScreen />} />

            <Route path="/a/:id" element={<ArticleScreen />} />
            <Route path="/e/:id" element={<EntityScreen />} />

            <Route path="/e/null" element={<HomeScreen />} />
            <Route path="/a/null" element={<HomeScreen />} />
            <Route path="/null" element={<HomeScreen />} />

            {/* Notícias */}
            <Route path="/noticias" element={<ListNewsScreen />} />
            <Route path="/noticias/:id/:title" element={<NewsScreen />} />
            <Route path="/noticias/:id" element={<NewsScreen />} />

            {/* Downloads / Diretórios */}
            <Route path="/categoria/:id" element={<DirectoryScreen />} />
            <Route path="/diretorio/:id" element={<FilesScreen />} />
            <Route path="/publicacoes" element={<DirectoryScreen />} />

            {/* Contato, Localização, Busca, Vídeos */}
            <Route path="/contato" element={<ContactScreen />} />
            <Route path="/telefones" element={<ContactScreen />} />
            <Route path="/localizacao" element={<LocationScreen />} />
            <Route path="/busca/:searchText" element={<SearchScreen />} />
            <Route path="/busca" element={<SearchScreen />} />
            <Route path="/videos" element={<ListVideosScreen />} />

            {/* Atalhos */}
            <Route path="/iptu" element={<Navigate to="/a/180" />} />
            <Route path="/e/secretaria-fazenda" element={<Navigate to="/e/23" />} />

            {/* 404 */}
            <Route path="/NotFound" element={<NotFoundScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    )
}